var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "campaign",
      class: { "campaign--full-height": _vm.$route.name === "campaignsAds" }
    },
    [
      _c(
        "h5",
        {
          staticClass: "campaign__name",
          class: {
            "campaign__name--absolute": _vm.$route.name === "campaignsAds"
          }
        },
        [_vm._v(_vm._s(_vm.currentCampaign.info.name))]
      ),
      _vm.ready ? _c("router-view") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }